export default __webpack_public_path__ + "static/media/tiger_standup.1b9fbe1e.png";